import request from "@/utils/jcRequest.js";


// 获取全局文件地址
export const getFileUrl = () => {
    return request.get(`/system/parameter/getParameterByTitle?title=BaseUrl`);
};

export const getParameter = (data: any) => {
    return request.get(`/system/parameter/getParameterByTitle?title=${data}`);
};
export const getTableList = () => {
    //return request.get('http://localhost:3000/wans');
    return request.get('/wans');
};
export const getItem = (data: any) => {
    //return request.get(`http://localhost:3000/wans/${data.id}`);
    return request.get(`/wans/${data.id}`);
};
export const deleteItem = (data: any) => {
    //return request.delete(`http://localhost:3000/wans/${data.id}`);
    return request.delete(`/wans/${data.id}`);
};

// 网站获取导航菜单
export const getMenuTree = (data: any) => {
    return request.get(`/sys/menu/tree?classfier=${data}`);
};

// 登录
export const login = (data: any) => {
    return request.post(`/user/sign/login`,data);
};

// 字典
export const getEnum = (data: any) => {
    return request.get(`/base/enum/selectAll?enumType=${data}`);
};

// 获取用户信息
export const getUserInfo = () => {
    return request.get(`/user/online/currentUserInfo`);
};


// 字典
export const getProduct = (data: any) => {
    return request.get(`/core/product/selectAll`);
};

// 获取用户信息
export const getAllAttr = () => {
    return request.get(`/core/attractInvestment/selectAll`);
};

// 获取试用产品
export const getSelectSample = () => {
    return request.get(`/core/product/selectSample`);
};


 
// 获取经典客户
export const getCustomer = () => {
    return request.get(`/core/customer/selectAll`);
};
//  查询所有合作流程
export const getAllCooperative = () => {
    return request.get(`/base/cooperative-process/selectAll`);
};

//  查询所有留言
export const getAllMessage = () => {
    return request.get(`/core/message/selectAll`);
};

//  查询所有数字展厅
export const getAllGallery = () => {
    return request.get(`/core/gallery/selectAll`);
};
//  查询所有解决方案
export const getAllSolution = () => {
    return request.get(`/core/schemeType/selectAll`);
};

  
//  查询关于我们
export const getAbout = () => {
    return request.get(`/core/aboutUs/selectAll`);
};

    